/* eslint-disable react/prop-types */
import classes from "./page-type-one.module.scss";

import Flex from "@/components-library/layout/flex";
import ComposedViewHeader from "@/composed-views/composed-view-header";
import ComposedViewSix from "@/composed-views/composed-view-six";
import ComposedViewSeven from "@/composed-views/composed-view-seven";
import { SERVICES } from "@/static-texts/services";
import CardViewService from "@/composed-views/card-view-service";
import ComposedViewInfiniteCarousel from "@/composed-views/composed-view-infinite-carousel";

function PageTypeOne({ content }) {
  return (
    <Flex
      align="flex-start"
      className={classes.container}
      direction="column"
      justify="flex-start"
    >
      <ComposedViewHeader
        header={content.header.header}
        title={content.header.title}
        subTitle={content.header.subTitle}
      />

      <ComposedViewSix
        header={content.types.header}
        title={content.types.title}
        columnOne={content.types.columnOne}
        columnTwo={content.types.columnTwo}
        className={classes.types}
      />

      <ComposedViewSeven
        title={content.benefitsFollowed.title}
        steps={content.benefitsFollowed.steps}
      />

      <ComposedViewInfiniteCarousel
        title={content.services.title}
        subTitle={content.services.subTitle}
        items={Object.keys(SERVICES).map((key) => SERVICES[key])}
        itemType={<CardViewService size={"md"} />}
        className={classes.services}
      />
    </Flex>
  );
}

export default PageTypeOne;
